import React from "react";
import Header from "../layout/header/Header";
import Footer from "../layout/footer/Footer";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";
import { HiOutlineArrowRight } from "react-icons/hi";
import { products } from "../json/products";
import { HiOutlineXMark } from "react-icons/hi2";

function Wishlist() {
  return (
    <>
      <Header />
      <Breadcrumb title={"Wishlist"} />
      <h1 className="font-semibold lg:text-4xl text-center my-10">
        My Wishlist
      </h1>
      <div className="max-w-6xl mx-auto mb-20">
        <table className="border border-gray-300 w-full text-left  rounded">
          <thead>
            <tr className="border-b border-gray-300 text-gray-500 w-full">
              <th className="font-normal p-3">Products</th>
              <th className="font-normal py-3">Price</th>
              <th className="font-normal py-3"></th>
            </tr>
          </thead>
          <tbody>
            {products?.slice(3,6).map((item, i) => (
              <tr className="border-b border-gray-200 w-full" key={i}>
                <td className="max-w-1/4 mx-3 flex items-center justify-start">
                  <img src={item?.thumbnail} className="object-contain h-24" alt="" />
                  <p>{item?.name}</p>
                </td>
                <td className="w-1/4">${item?.price}</td>
                
                <td className="w-1/4">
                  <div className="flex items-center justify-center space-x-1">
                    <button className="bg-primary px-4 py-2 text-white text-xs rounded-full">
                      Add to cart
                    </button>
                    <button className="bg-danger p-2 text-white text-xs rounded-full">
                      <HiOutlineXMark className="h-5 w-5" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex items-center justify-end m-4">
          <Link
            to={"/cart"}
            className=" text-primary text-right underline text-sm"
          >
            View Cart
          </Link>
          <HiOutlineArrowRight className="text-primary h-3" />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Wishlist;
